export abstract class Environment {
  abstract readonly production: boolean;
  abstract readonly apiUrl: string;
  abstract readonly logoutUrl: string;
  abstract readonly refreshTokenUrl: string;
  abstract readonly tokenHeaderKey: string;
}
